module.exports = __webpack_public_path__ + "img/product.c5bfc043.svg";